/* Save user pass on login page into localstorate temporarily */
const passwordInput = document.querySelector('[name="customer[password]"]'); 
const loginSubmitBtn = document.querySelector('#customer_login [type="submit"]'); 
if (passwordInput && loginSubmitBtn) { 
  localStorage.setItem("temp_customer_pass", passwordInput.value); 
  passwordInput.addEventListener('keyup', (e) => { 
    localStorage.setItem("temp_customer_pass", e.target.value); 
  }); 
  loginSubmitBtn.addEventListener('click', (e) => { 
    localStorage.setItem("temp_customer_pass", passwordInput.value); 
  }); 
} 
